import { useMutation, useQueryClient } from "react-query";
import { makeAuthedRequest } from "utils/makeAuthedRequest";

const useW9 = () => {
  const queryClient = useQueryClient();

  const confirmW9 = async ({ entityId }) => {
    const response = await makeAuthedRequest(
      `v1/settings/sub-entity/w9/confirm/${entityId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const body = await response.json();
      throw new Error(body.message || "Failed to confirm W-9");
    }

    // Only attempt to parse JSON if there is a response body
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  };

  const uploadW9 = async ({ entityId, fileData }) => {
    const response = await makeAuthedRequest(
      `v1/settings/sub-entity/w9/confirm/${entityId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fileData }),
      }
    );

    if (!response.ok) {
      const body = await response.json();
      throw new Error(body.message || "Failed to upload W-9 document");
    }

    // Only attempt to parse JSON if there is a response body
    const text = await response.text();
    return text ? JSON.parse(text) : {};
  };

  return {
    useConfirmW9: useMutation(confirmW9, {
      onSuccess: () => {
        queryClient.invalidateQueries(["subEntityInfo"]);
      },
    }),
    useUploadW9: useMutation(uploadW9, {
      onSuccess: () => {
        queryClient.invalidateQueries(["subEntityInfo"]);
      },
    }),
  };
};

export default useW9;
